"use strict";
Object.defineProperty(exports, "__esModule", {
    value: true
});
Object.defineProperty(exports, "default", {
    enumerable: true,
    get: function() {
        return _default;
    }
});
const _nocodbsdk = require("nocodb-sdk");
const _UpCloudPlugin = /*#__PURE__*/ _interop_require_default(require("./UpCloudPlugin"));
function _interop_require_default(obj) {
    return obj && obj.__esModule ? obj : {
        default: obj
    };
}
const config = {
    builder: _UpCloudPlugin.default,
    id: 'upcloud',
    title: 'UpCloud',
    recoveryTitle: 'UpCloud Object Storage',
    version: '0.0.4',
    logo: 'plugins/upcloud.png',
    description: 'The perfect home for your data. Thanks to the S3-compatible programmable interface,\n' + 'you have a host of options for existing tools and code implementations.\n',
    tags: 'Storage',
    inputs: {
        title: 'Configure UpCloud Object Storage',
        items: [
            {
                key: 'bucket',
                label: 'Bucket Name',
                placeholder: 'Bucket Name',
                type: _nocodbsdk.XcType.SingleLineText,
                required: true
            },
            {
                key: 'endpoint',
                label: 'Endpoint',
                placeholder: 'Endpoint',
                type: _nocodbsdk.XcType.SingleLineText,
                required: true
            },
            {
                key: 'access_key',
                label: 'Access Key',
                placeholder: 'Access Key',
                type: _nocodbsdk.XcType.SingleLineText,
                required: true
            },
            {
                key: 'access_secret',
                label: 'Access Secret',
                placeholder: 'Access Secret',
                type: _nocodbsdk.XcType.Password,
                required: true
            },
            {
                key: 'acl',
                label: 'Access Control Lists (ACL)',
                placeholder: 'Default set to public-read',
                type: _nocodbsdk.XcType.SingleLineText,
                required: false
            }
        ],
        actions: [
            {
                label: 'Test',
                placeholder: 'Test',
                key: 'test',
                actionType: _nocodbsdk.XcActionType.TEST,
                type: _nocodbsdk.XcType.Button
            },
            {
                label: 'Save',
                placeholder: 'Save',
                key: 'save',
                actionType: _nocodbsdk.XcActionType.SUBMIT,
                type: _nocodbsdk.XcType.Button
            }
        ],
        msgOnInstall: 'Successfully configured! Attachments will now be stored in UpCloud Object Storage.',
        msgOnUninstall: ''
    },
    category: 'Storage'
};
const _default = config;
